import { defineMessages } from 'react-intl';

import { ASSIGNMENT_STEPS } from './constants';

export const assignmentStepperMessages = defineMessages<ASSIGNMENT_STEPS>({
  [ASSIGNMENT_STEPS.SUBMITTED]: {
    defaultMessage: 'Envoyé',
  },

  [ASSIGNMENT_STEPS.CORRECTED]: {
    defaultMessage: 'Corrigé',
  },

  [ASSIGNMENT_STEPS.APPOINTMENT_SCHEDULED]: {
    defaultMessage: 'Rendez-vous pris',
  },

  [ASSIGNMENT_STEPS.ORAL_DONE]: {
    defaultMessage: 'Oral réalisé',
  },
});
